import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

export const BloxContentIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        id="BloxContentIcon"
        data-testid="BloxContentIcon"
        className="bloxicon"
        width="91"
        height="100"
        viewBox="0 0 91 100"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M82.7732 19.0818L53.3646 2.10268C48.5267 -0.699392 42.2374 -0.701156 37.4101 2.10092L7.95743 19.1029C3.6591 21.5982 0.737109 26.0482 0.149009 30.9461C0.0520209 31.6541 0 32.3753 0 33.101V67.0688C0 71.3143 1.70964 75.3463 4.6281 78.2965C4.89878 75.9106 5.26028 73.3069 5.73817 71.1115L7.55096 62.7925V33.1001C7.55096 32.7183 7.58006 32.3383 7.63913 31.9054C7.95214 29.2902 9.48896 26.9449 11.7691 25.6205L41.19 8.63791C43.7302 7.16017 47.0339 7.16105 49.5838 8.63968L79.0188 25.6355C81.597 27.13 83.1973 29.9127 83.1973 32.8938V66.8616C83.1973 67.2452 83.1682 67.6234 83.1091 68.0563C82.7961 70.6715 81.2593 73.0168 78.9827 74.3412L49.5609 91.3255C47.0172 92.7971 43.7152 92.7989 41.1653 91.3238L34.1663 87.2856L27.6293 83.5101C25.842 85.2982 23.6289 87.2141 21.6971 88.803L37.3871 97.8608C39.8074 99.2618 42.5654 100.001 45.3666 100.001C48.1678 100.001 50.924 99.2618 53.3408 97.8625L82.7925 80.8605C87.0909 78.3644 90.0129 73.9153 90.601 69.0156C90.698 68.3059 90.75 67.5864 90.75 66.8625V32.8946C90.75 27.2314 87.7081 21.9473 82.774 19.0835L82.7732 19.0818Z"
          fill="currentColor"
        />
        <path
          d="M77.5772 65.4775H34.2191C33.49 66.6546 32.7996 67.6704 32.2291 68.5644L30.7699 70.7572H77.5772C79.04 70.7572 80.2179 69.5801 80.2179 68.1165C80.2179 66.6529 79.0409 65.4784 77.5772 65.4784V65.4775Z"
          fill="currentColor"
        />
        <path
          d="M77.5773 53.0542H41.5665C40.6346 54.8009 39.6197 56.5863 38.6049 58.333H77.5773C79.0401 58.333 80.218 57.1559 80.218 55.6949C80.218 54.2339 79.0409 53.0542 77.5773 53.0542Z"
          fill="currentColor"
        />
        <path
          d="M77.5773 40.5913H48.2666L45.4636 45.8701H77.5773C79.04 45.8701 80.218 44.6931 80.218 43.2294C80.218 41.7658 79.0409 40.5905 77.5773 40.5905V40.5913Z"
          fill="currentColor"
        />
        <path
          d="M77.5772 28.168H54.9235L52.124 33.4468H77.5772C79.04 33.4468 80.2179 32.2697 80.2179 30.806C80.2179 29.3424 79.0409 28.168 77.5772 28.168Z"
          fill="currentColor"
        />
        <path
          d="M53.2492 25.5484C54.3275 23.5364 53.7412 21.154 52.0712 19.7283L54.3072 15.5516C54.7833 14.6637 54.4501 13.5616 53.5622 13.0855L49.6368 10.9826C48.7525 10.5091 47.6468 10.8398 47.1707 11.7276L44.9346 15.9025C42.8212 15.3003 40.5138 16.1309 39.4354 18.1447L37.8378 21.1222L51.6506 28.526L53.2483 25.5484H53.2492Z"
          fill="currentColor"
        />
        <path
          d="M10.7392 85.2481C10.696 85.9217 11.0523 86.5583 11.6474 86.8775C12.2417 87.1949 12.9673 87.1394 13.5025 86.7347C14.2758 86.1483 19.9566 81.7971 23.2437 78.4087L12.2972 72.5409C11.2859 77.1796 10.8027 84.2826 10.7392 85.2481Z"
          fill="currentColor"
        />
        <path
          d="M49.6887 32.1913L32.6885 23.0788L34.1795 20.2935C34.7543 19.2248 34.3496 17.897 33.2836 17.3239C32.2132 16.7534 30.8854 17.1511 30.314 18.2197L20.0571 37.3528C19.4822 38.4232 19.8869 39.751 20.9529 40.3242C22.0233 40.8973 23.3512 40.497 23.9225 39.4266L30.7223 26.7414L33.9097 28.4502L23.0346 48.7357C19.9187 54.5514 15.5551 64.0554 13.6198 68.605L25.7591 74.6033C28.4827 70.4857 33.7148 61.9878 36.8475 56.1394L49.6887 32.1904V32.1913Z"
          fill="currentColor"
        />
      </svg>
    </SvgIcon>
  );
};
